
export enum ActionStatusTypeEnum {  // action required and also used for growl msg
  Save = "saved",
  Update = "updated",
  Submit = "submitted",
  Edit = "status updated for edit",
  Resubmit = "resubmitted",
  AddressAdded = "address added",
  AddressUpdated = "address updated",
  AddressDeleted = "address deleted",
  ContactAdded = "contact added",
  ContactUpdated = "contact updated",
  ContactDeleted = "contact deleted",
  PaymentAdded = "payment added",
  PaymentUpdated = "payment updated",
  PaymentDeleted = "payment deleted",
  AdditionalInfoAdded = "additional info added",
  AdditionalInfoUpdated = "additional info updated",
  AdditionalInfoDeleted = "additional info deleted",
  SalesTaxAdded = "sales tax added",
  SalesTaxUpdated = "sales tax updated",
  SalesTaxDeleted = "sales tax deleted"
}
